import { ApiClient } from "./api-client";

export function getRooms(queryParams) {
  return ApiClient.getInstance().get('/room', { params: queryParams }).catch((error) => {
    console.error('Error fetching user rooms:', error);
    throw error;
  });
}

export function getRoomsPlain() {
  return ApiClient.getInstance().get('/room/plain').catch((error) => {
    console.error('Error fetching user rooms:', error);
    throw error;
  });
}

export function getRoomsWithAvailability(params) {
  return ApiClient.getInstance().get('/room/available', { params: params }).catch((error) => {
    console.error('Error fetching user rooms:', error);
    throw error;
  });
}

export function getRoom(id) {
  return ApiClient.getInstance().get(`/room/${id}`).catch((error) => {
    console.error('Error fetching user room:', error);
    throw error;
  });
}

export function createRoom(
  name,
  capacity, 
  floor,
  openTimeHour, 
  openTimeMinute, 
  closeTimeHour, 
  closeTimeMinute, 
  active, 
  type, 
  interval, 
  credits, 
  maxBookingTime
) {
  var openTime = `${openTimeHour}:${openTimeMinute}`;
  var closeTime = `${closeTimeHour}:${closeTimeMinute}`;
  return ApiClient.getInstance().post('/room', { name, capacity, floor, openTime, closeTime, active, typeId: type, interval, credits, maxBookingTime }).catch((error) => {
    console.error('Error creating user room:', error);
    throw error;
  });
}

export function updateRoom(id, name, capacity, floor, openTimeHour, openTimeMinute, closeTimeHour, closeTimeMinute, active, type) {
  var openTime = `${openTimeHour}:${openTimeMinute}`;
  var closeTime = `${closeTimeHour}:${closeTimeMinute}`;
  return ApiClient.getInstance().put('/room', { id, name, capacity, floor, openTime, closeTime, active, typeId: type }).catch((error) => {
    console.error('Error updating user room:', error);
    throw error;
  });
}

export function updateRoomImage(roomId, imageFile) {
  return ApiClient.getInstance().put('/room/:id/image', imageFile, { headers: { 'Content-Type': imageFile.type || 'image/png', }, urlParams: { id: roomId } }).catch((error) => {
    console.error('Error updating room image:', error);
    throw error;
  });
}

export function deleteRoom(id) {
  return ApiClient.getInstance().delete(`/room/${id}`).catch((error) => {
    console.error('Error deleting user room:', error);
    throw error;
  });
}